import type { MeetingParticipant } from "@/schema"

export function meetingShareRecipients(
  participants: MeetingParticipant[],
  internalParticipants: MeetingParticipant[] = []
) {
  const internalEmails = new Set(internalParticipants.map((participant) => participant.email?.trim().toLowerCase()))
  const recipients = new Map<string, { email: string; first_name?: string; last_name?: string }>()
  for (const participant of participants) {
    const email = participant.email?.trim().toLowerCase()
    if (!email || internalEmails.has(email) || participant.status === "no" || recipients.has(email)) continue
    const [first_name, ...rest] = participant.name?.trim().split(/\s+/) ?? []
    recipients.set(email, { email, first_name: first_name || undefined, last_name: rest.join(" ") || undefined })
  }
  return [...recipients.values()]
}
